// extracted by mini-css-extract-plugin
export var body = "_3r-1";
export var bodyPadded = "_3r-2";
export var chevron = "_3r-4";
export var chevronOpen = "_3r-5";
export var header = "_3r-0";
export var icon = "_3r-3";